import { useRecoilValue } from 'recoil';
import CouchTopLine from './CouchTopLine';
import { PlaneView } from '~/engine/view/views/PlaneView';
import { usePlaneRedrawTick } from '~/hooks/viewer/annotationOverlay';
import { viewManagerState } from '~/state/atoms/engineAtoms';

export interface CouchTopLineComponentProps {
    view: PlaneView | null;
}

/**
 * Forces a re-render of the line on slice scroll, zoom and a view changing
 * sides of a fusion, which are the hook's default events. Scroll and zoom
 * move the world-anchored line and ghost; the fusion side decides whether
 * the line is drawn on the view at all, since it is drawn only on a view
 * that shows the primary image.
 *
 * `renderTick` is threaded down as an explicit prop rather than left as an
 * implicit "any re-render redraws" trigger: `CouchTopLine`'s curve-preview
 * effect depends on it explicitly, so `react-hooks/exhaustive-deps` can
 * actually check that effect's dependency array instead of the effect
 * omitting one entirely.
 */
const CouchTopLineComponent = ({ view }: CouchTopLineComponentProps) => {
    const viewManager = useRecoilValue(viewManagerState);
    const renderTick = usePlaneRedrawTick(viewManager);

    return <CouchTopLine view={view} renderTick={renderTick} />;
};

export default CouchTopLineComponent;
